<!--基线肝穿的检查里增加一项：全外显子基因测序（可选）上传图片（可选）-->
<script setup>
import { reactive, onMounted, computed } from "vue";
// import { useCrfStore } from "@/stores/crf";
import upload from "@/components/upload1.vue"

// 定义组件属性
const props = defineProps({
  formModel: {},
  type: null
});

// 表单对象
const model = reactive(props.formModel);

// 节省代码长度，在模板中使用
const crfFields = computed(() => {
  return model.fields[props.type];
});


</script>
<template>
  <template v-if="crfFields">
    <div style="display:flex;">
      <h2>基因测序（可选）</h2>
      <upload :type="props.type" :data="model" name="qwxzjycx"></upload>
    </div>
  </template>
</template>

<style scoped>
</style>